export const defaultMeta = {
  title: "МТК - Личный кабинет",
  h1: "Личный кабинет",
  breadcrumbs: [
    {
      url: "/",
      name: "Главная",
    },
    {
      name: "Личный кабинет",
    },
  ],
};

export const defaultLinks = [
  {
    title: "Заказы",
    route: "/account/orders/",
  },
];
